// 9fbef606107a605d69c0edbcd8029e5d
const cartPrefix = 'GET_CART_QUERY';
const baseRetryConfig = {
  maxAttempt: 2,
  maxDelay: 500,
};

export default {
  ADD_GIFT_CARD: {
    ...baseRetryConfig,
  },
  ADD_ITEMS: {
    ...baseRetryConfig,
  },
  APPLY_COUPON: {
    ...baseRetryConfig,
  },
  DELETE_COUPON: {
    ...baseRetryConfig,
  },
  GET_INVENTORY: {
    ...baseRetryConfig,
  },
  GET_INVENTORY_DETAILS: {
    ...baseRetryConfig,
    preFix: 'GET_BASKET_INVENTORY_QUERY',
    defaultTTL: 29.5,
  },
  GET_CART_ITEMS: {
    ...baseRetryConfig,
    preFix: cartPrefix,
    defaultTTL: 30,
  },
  GET_BONUS_POINT_DAY: {
    ...baseRetryConfig,
    preFix: 'GET_BONUS_POINT_DAY',
    defaultTTL: 30,
  },
  GET_BIA_PRODUCTS: {
    ...baseRetryConfig,
    preFix: 'GET_BIA_PRODUCTS',
    defaultTTL: 30,
  },
  GET_CART_DETAILS: {
    ...baseRetryConfig,
    preFix: cartPrefix,
    defaultTTL: 30,
  },
  GET_DEFAULT_SHIPPING_METHODS: {
    ...baseRetryConfig,
    preFix: 'GET_DEFAULT_SHIPPING_METHODS',
    defaultTTL: 1440,
  },
  GET_GIFT_OPTIONS: {
    ...baseRetryConfig,
    preFix: 'GET_GIFT_OPTIONS',
    defaultTTL: 1440,
  },
  GET_SHIPPING_METHODS: {
    ...baseRetryConfig,
  },
  PAYPAL_AUTH: {
    ...baseRetryConfig,
  },
  DELETE_GIFT_CARD: {
    ...baseRetryConfig,
  },
  REMOVE_ITEM: {
    ...baseRetryConfig,
  },
  CREATE_ORDER: {
    ...baseRetryConfig,
  },
  ADD_PAYMENT_INSTRUMENTS: {
    ...baseRetryConfig,
  },
  UPDATE_ITEM: {
    ...baseRetryConfig,
  },
  UPDATE_STORE_ITEM: {
    ...baseRetryConfig,
  },
  UPDATE_SHIPPING_DETAILS: {
    ...baseRetryConfig,
  },
  UPDATE_SHIPPING_METHODS: {
    ...baseRetryConfig,
  },
  // added for address book
  ADD_CUSTOMER_ADDRESS: {
    ...baseRetryConfig,
  },
  UPDATE_CUSTOMER_ADDRESS: {
    ...baseRetryConfig,
  },
  DELETE_CUSTOMER_ADDRESS: {
    ...baseRetryConfig,
  },
  GET_ADDRESSES: {
    ...baseRetryConfig,
    preFix: 'GET_ADDRESSES',
  },
  ADD_FAV_STORE: {
    ...baseRetryConfig,
  },
  ADD_CUSTOMER_GIFT_CARD: {
    ...baseRetryConfig,
  },
  GET_ALL_PAYMENT_CARDS: {
    ...baseRetryConfig,
  },
  GET_CUSTOMER_GIFT_CARD_BALANCE: {
    ...baseRetryConfig,
  },
  GET_FAV_STORE: {
    ...baseRetryConfig,
    preFix: 'GET_FAV_STORE',
  },
  DELETE_CUSTOMER_GIFT_CARD: {
    ...baseRetryConfig,
  },
  GET_WISHLIST_BY_ID: {
    ...baseRetryConfig,
    prefix: 'GET_WISHLIST_BY_ID',
  },
  GET_BOSS_UNAVAILABLE_ITEMS: {
    ...baseRetryConfig,
    prefix: 'GET_BOSS_UNAVAILABLE_ITEMS',
    defaultTTL: 30,
  },
  REMOVE_ITEM_FROM_WISHLIST: {
    ...baseRetryConfig,
  },
  ADD_CUSTOMER_CREDIT_CARD: {
    ...baseRetryConfig,
  },
  UPDATE_CUSTOMER_CREDIT_CARD: {
    ...baseRetryConfig,
  },
  DELETE_PAYMENT_INSTRUMENT: {
    ...baseRetryConfig,
  },
  GET_REGISTERED_CUSTOMER: {
    ...baseRetryConfig,
    prefix: 'GET_REGISTERED_CUSTOMER',
  },
  // get order history
  GET_ORDER_HISTORY: {
    ...baseRetryConfig,
    prefix: 'GET_ORDER_HISTORY',
  },
  // get all coupons
  GET_ALL_COUPONS: {
    ...baseRetryConfig,
    prefix: 'GET_ALL_COUPONS',
  },
  // get order details
  GET_ORDER_DETAILS: {
    ...baseRetryConfig,
    prefix: 'GET_ORDER_DETAILS',
  },
  // get coupon terms and conditions
  GET_COUPON_TERMS_AND_CONDITIONS: {
    ...baseRetryConfig,
    prefix: 'GET_COUPON_TERMS_AND_CONDITIONS',
  },
  GET_PREFERENCES: {
    ...baseRetryConfig,
    prefix: 'GET_PREFERENCES',
  },
  UPDATE_PREFERENCE: {
    ...baseRetryConfig,
  },
  STORE_AND_PRODUCT_INFO: {
    ...baseRetryConfig,
  },
  USER_BOPIS_STORES: {
    ...baseRetryConfig,
  },
  GET_BOPIS_INVENTORY: {
    ...baseRetryConfig,
  },
  ADD_STORE_ITEMS: {
    ...baseRetryConfig,
  },
  APPLE_VENMO_SUBMIT_ORDER: {
    ...baseRetryConfig,
    prefix: 'APPLE_VENMO_SUBMIT_ORDER',
  },
  GET_CART_DETAILS_COMPLETE: {
    ...baseRetryConfig,
    preFix: cartPrefix,
    defaultTTL: 30,
  },
  EXPRESS_CHECKOUT: {
    ...baseRetryConfig,
    prefix: 'EXPRESS_CHECKOUT',
  },
  GET_PUBLIC_WISHLIST: {
    ...baseRetryConfig,
  },
  Add_ITEM_TO_SFL: {
    ...baseRetryConfig,
  },
  SHIPMENT_PRODUCT_INVENTORY: {
    ...baseRetryConfig,
  },
  MOVE_ITEM_TO_SFL: {
    ...baseRetryConfig,
  },
  // get all payment cards and address List
  GET_ADDRESSES_AND_ALL_PAYMENT_CARDS: {
    ...baseRetryConfig,
    prefix: 'GET_ADDRESSES_AND_ALL_PAYMENT_CARDS',
  },
  ADD_STORE_DETAILS: {
    ...baseRetryConfig,
  },
  GET_ALL_STORES: {
    ...baseRetryConfig,
    prefix: 'GET_ALL_STORES',
  },
  SAVE_USER_BROWSE_HISTORY: {
    ...baseRetryConfig,
  },
  GET_ORDER_LIST_BY_SHIPMENT: {
    ...baseRetryConfig,
    prefix: 'GET_ORDER_LIST_BY_SHIPMENT',
  },
  GET_LOYALTY_BENEFITS: {
    ...baseRetryConfig,
    preFix: 'GET_LOYALTY_BENEFITS',
    defaultTTL: 30,
  },
};
